import ApiService from '@/services/core/api.service'

const RawDataService = {
  async get (query) {
    return ApiService.get(`admin/raw-data?${query}`)
  },

  async put (payload) {
    return ApiService.put(`admin/raw-data/${payload.agent}`, payload)
  }
}

export default RawDataService
